import AdjustIcon from '@mui/icons-material/LibraryBooks';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
export const getJobSiteCandidateDetails = (candidate) => [
  {
    icon: <LocationOnIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `${candidate.CurrentLocation}`,
    tooltip: 'Candidate Locaion',
  },
  {
    icon: <WorkIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Job Title :${candidate.DesiredJobTitle ? candidate.DesiredJobTitle : 'N/A'}`,
    tooltip: 'Preferred Job Title',
  },
  {
    icon: <PeopleIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Experience: ${candidate.WorkExperience ? candidate.WorkExperience : 'N/A'}`,
    tooltip: 'Work Experience',
  },
  {
    icon: <HiOutlineCurrencyDollar color="#888A8E" size="1.27rem" />,
    label: candidate.CurrentSalary
      ? `Salary: ${candidate.CurrentSalary?.LowerValue && ''}-${
          candidate.CurrentSalary?.UpperValue
        } | Rate Type: ${candidate.CurrentSalary?.RateType}`
      : 'Salary: N/A',
    tooltip: 'Current Salary',
  },
  {
    icon: <HiOutlineCurrencyDollar color="#888A8E" size="1.27rem" />,
    label: candidate.DesiredSalary
      ? `Desired Salary:  ${candidate.DesiredSalary?.LowerValue && ''}-${
          candidate.DesiredSalary?.UpperValue
        } | Rate Type: ${candidate.DesiredSalary?.RateType}`
      : 'Desired Salary: N/A',
    tooltip: 'Desired Salary',
  },
  {
    icon: <AdjustIcon sx={{ color: '#888A8E', fontSize: '1.27rem' }} />,
    label: `Willing to Relocate: ${candidate.DesiredLocations}`,
    tooltip: 'Relocation Preference',
  },
];
